import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Link from 'shared/SlashLink';
import blogs from '../../api/blogs';
import icon from '../../images/icons/icon_search.svg';
import icon1 from '../../images/icons/icon_calendar.svg';

const BlogSidebar = ({ currentSlug } = {}) => {
    const location = useLocation();
    const navigate = useNavigate();

    const params = new URLSearchParams(location.search);
    const initialQ = params.get('q') || '';
    const activeTag = params.get('tag') || '';
    const activeCat = params.get('cat') || '';

    const [q, setQ] = useState(initialQ);
    useEffect(() => { setQ(initialQ); }, [initialQ]);

    const ClickHandler = () => window.scrollTo(10, 0);

    const submitSearch = (e) => {
        e.preventDefault();
        const next = new URLSearchParams(location.search);
        if (q.trim()) next.set('q', q.trim());
        else next.delete('q');
        next.delete('page');
        navigate(`/blog?${next.toString()}`);
        ClickHandler();
    };

    const sortedRecent = useMemo(() => {
        const arr = [...blogs].sort((a, b) => new Date(b.date) - new Date(a.date));
        return arr.filter((b) => b.slug !== currentSlug).slice(0, 4);
    }, [currentSlug]);

    const categoryCounts = useMemo(() => {
        const m = new Map();
        blogs.forEach((b) => {
            if (b.category) m.set(b.category, (m.get(b.category) || 0) + 1);
        });
        return Array.from(m.entries()).sort((a, b) => b[1] - a[1]);
    }, []);

    const tagCounts = useMemo(() => {
        const m = new Map();
        blogs.forEach((b) => {
            (b.tags || []).forEach((t) => m.set(t, (m.get(t) || 0) + 1));
        });
        return Array.from(m.entries())
            .sort((a, b) => b[1] - a[1])
            .slice(0, 15);
    }, []);

    return (
        <div className="col-lg-4">
            <aside className="sidebar ps-lg-5">
                <div className="search_form">
                    <h3 className="sidebar_widget_title">Search</h3>
                    <form className="form-group" onSubmit={submitSearch}>
                        <input
                            className="form-control"
                            type="search"
                            name="search"
                            placeholder="Search posts, tags, keywords…"
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                        />
                        <button type="submit" aria-label="Search">
                            <img src={icon} alt="Search" />
                        </button>
                    </form>
                </div>

                <div className="post_list_block">
                    <h3 className="sidebar_widget_title">Recent Posts</h3>
                    <ul className="unordered_list_block">
                        {sortedRecent.map((b) => (
                            <li key={b.slug}>
                                <h3 className="post_title">
                                    <Link onClick={ClickHandler} to={`/blog-single/${b.slug}`}>{b.title}</Link>
                                </h3>
                                <ul className="post_meta unordered_list">
                                    <li>
                                        <Link onClick={ClickHandler} to={`/blog-single/${b.slug}`}>
                                            <img src={icon1} alt="Calendar" /> {b.create_at}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to={`/blog-single/${b.slug}`}>
                                            <i className="fa-regular fa-clock" aria-hidden="true"></i> {b.readTime} min
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="post_category_wrap">
                    <h3 className="sidebar_widget_title">Categories</h3>
                    <ul className="post_category_list unordered_list_block">
                        {categoryCounts.map(([cat, count]) => (
                            <li key={cat} className={activeCat === cat ? 'active' : ''}>
                                <Link onClick={ClickHandler} to={`/blog?cat=${encodeURIComponent(cat)}`}>
                                    <i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i>
                                    <span>{cat}</span>
                                    <span>({String(count).padStart(2, '0')})</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="popular_tags">
                    <h3 className="sidebar_widget_title">Popular Tags</h3>
                    <ul className="tags_list unordered_list">
                        {tagCounts.map(([tag]) => (
                            <li key={tag}>
                                <Link
                                    onClick={ClickHandler}
                                    to={`/blog?tag=${encodeURIComponent(tag)}`}
                                    style={activeTag === tag ? { background: 'var(--bs-primary)', color: '#fff' } : undefined}
                                >
                                    {tag}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </aside>
        </div>
    );
};

export default BlogSidebar;
